"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferClient = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const __1 = require("../");
const types_1 = require("../types");
const lodash_1 = require("lodash");
class OfferClient {
    constructor(ctx, publicKey, data, pda, configId) {
        this.ctx = ctx;
        this.data = data;
        this.publicKey = publicKey;
        this.pda = pda;
        this.configId = configId;
    }
    static getOffer(ctx, configId, offerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId);
            const offerPubkey = pda.getOfferPDA(offerId).key;
            const offerData = (yield ctx.program.account.offer.fetch(offerPubkey));
            if (!offerData) {
                throw new Error(`Offer ${offerId} not found`);
            }
            return new OfferClient(ctx, offerPubkey, Object.assign(Object.assign({}, offerData), { pubkey: offerPubkey }), pda, configId);
        });
    }
    static makeOffer(ctx, configId, side, maker, tokenMint, bondType, minTradeSize, tokenAmount, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId);
            const configAddress = pda.getConfigPDA().key;
            let configAccount = (yield ctx.program.account.escrowConfig.fetch(configAddress));
            if (!configAccount) {
                throw new Error(`Escrow config ${configAddress} not found`);
            }
            const offerPDA = pda.getOfferPDA(configAccount.currentOfferId);
            const offerTokenVaultPDA = pda.getOfferTokenVaultPDA(configAccount.currentOfferId);
            const offerNativeVaultPDA = pda.getOfferNativeVaultPDA(configAccount.currentOfferId);
            const configRentVaultPDA = pda.getConfigRentVaultPDA();
            const makerTokenAccount = yield (0, common_sdk_1.deriveATA)(maker, tokenMint);
            const tokenInfoPDA = pda.getTokenInfoPDA(tokenMint);
            // add kyc cert if is buy offer
            let prependIxs = [];
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Buy)) {
                // Get or create default joinner kyc cert
                const userKycCertPda = pda.getKycCertPDA(tokenMint, maker);
                const accountInfo = yield ctx.connection.getAccountInfo(userKycCertPda.key);
                if (accountInfo == null) {
                    const initKycCertIx = (yield ctx.ixs.initKycCertIx({
                        escrowConfig: configAddress,
                        caller: maker,
                        user: maker,
                        tokenMint,
                        kycCertPubkey: userKycCertPda.key,
                        kycCertBump: userKycCertPda.bump,
                    })).ix;
                    if (!initKycCertIx) {
                        throw new Error("Fail to get the initialize kyc cert instruction");
                    }
                    prependIxs.push(initKycCertIx);
                }
                remainingAccounts = (0, __1.getRemaningAccounts)([userKycCertPda.key]);
            }
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Buy)) {
                let buyerKycCert = pda.getKycCertPDA(tokenMint, maker);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            const tx = (yield ctx.ixs.makeOfferIx({
                escrowConfig: configAddress,
                configRentVault: configRentVaultPDA.key,
                side: side,
                bondType: bondType,
                offerPDA,
                tokenMint,
                tokenInfo: tokenInfoPDA.key,
                userTokenAccount: makerTokenAccount,
                offerTokenVaultPDA,
                offerNativeVaultPDA,
                user: maker,
                minTradeSize,
                tokenAmount: tokenAmount,
                fiatAmount: fiatAmount,
                remainingAccounts,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return { tx, id: configAccount.currentOfferId };
        });
    }
    cancelOffer() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentOfferId = this.data.offerId;
            const tokenVaultAccount = this.pda.getOfferTokenVaultPDA(currentOfferId);
            const nativeVaultAccount = this.pda.getOfferNativeVaultPDA(currentOfferId);
            const maker = this.data.makerAuthority;
            const tokenMint = this.data.tokenMint;
            const makerTokenAccount = yield (0, common_sdk_1.deriveATA)(maker, tokenMint);
            const configRentVaultPDA = this.pda.getConfigRentVaultPDA();
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(this.data.side, types_1.TradeSide.Buy)) {
                let buyerKycCert = this.pda.getKycCertPDA(tokenMint, maker);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            const tx = (yield this.ctx.ixs.cancelOfferIx({
                offer: this.publicKey,
                tokenMint,
                userTokenAccount: makerTokenAccount,
                tokenVault: tokenVaultAccount.key,
                nativeVault: nativeVaultAccount.key,
                configRentVault: configRentVaultPDA.key,
                user: maker,
                remainingAccounts,
            })).toTx();
            return { tx };
        });
    }
    requestCreateTrade(user, tokenAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tokenMint, escrowConfig, offerId } = this.data;
            let prependIxs = [];
            // Get or create joiner token acccount
            const _a = yield (0, common_sdk_1.resolveOrCreateATA)(this.ctx.connection, user, tokenMint, () => this.ctx.fetcher.getTokenAccountRentExempt(), undefined, user), { address: userTokenAccount } = _a, instruction = __rest(_a, ["address"]);
            prependIxs.push(instruction);
            let configAccount = (yield this.ctx.program.account.escrowConfig.fetch(escrowConfig));
            if (!configAccount) {
                throw new Error(`Escrow config ${escrowConfig} not found`);
            }
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(this.data.side, types_1.TradeSide.Sell)) {
                // Get or create default joinner kyc cert
                const userKycCertPda = this.pda.getKycCertPDA(tokenMint, user);
                const accountInfo = yield this.ctx.connection.getAccountInfo(userKycCertPda.key);
                if (accountInfo == null) {
                    const initKycCertIx = (yield this.ctx.ixs.initKycCertIx({
                        escrowConfig,
                        caller: user,
                        user,
                        tokenMint,
                        kycCertPubkey: userKycCertPda.key,
                        kycCertBump: userKycCertPda.bump,
                    })).ix;
                    if (!initKycCertIx) {
                        throw new Error("Fail to get the initialize kyc cert instruction");
                    }
                    prependIxs.push(initKycCertIx);
                }
                remainingAccounts = (0, __1.getRemaningAccounts)([userKycCertPda.key]);
            }
            const tx = (yield this.ctx.ixs.requestCreateTradeIx({
                escrowConfig,
                offer: this.publicKey,
                tradePDA: this.pda.getTradePDA(configAccount.currentTradeId),
                tokenMint,
                tokenInfo: this.pda.getTokenInfoPDA(tokenMint).key,
                user,
                userTokenAccount,
                offerTokenVaultPDA: this.pda.getOfferTokenVaultPDA(offerId),
                offerNativeVaultPDA: this.pda.getOfferNativeVaultPDA(offerId),
                tradeTokenVaultPDA: this.pda.getTradeTokenVaultPDA(configAccount.currentTradeId),
                tradeNativeVaultPDA: this.pda.getTradeNativeVaultPDA(configAccount.currentTradeId),
                tokenAmount,
                configRentVault: this.pda.getConfigRentVaultPDA().key,
                remainingAccounts,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return { tx, id: configAccount.currentTradeId };
        });
    }
}
exports.OfferClient = OfferClient;
